import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-vehicle-info-thank-you-dialog",
  templateUrl: "./vehicle-info-thank-you-dialog.component.html",
  styleUrls: ["./vehicle-info-thank-you-dialog.component.scss"]
})
export class VehicleInfoThankYouDialogComponent {
  constructor(public dialogRef: MatDialogRef<VehicleInfoThankYouDialogComponent>) {}
}
